import { render, staticRenderFns } from "./tasktracking.vue?vue&type=template&id=95c41a44&"
import script from "./tasktracking.vue?vue&type=script&lang=js&"
export * from "./tasktracking.vue?vue&type=script&lang=js&"
import style0 from "./tasktracking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports